//  These are the 4 header patterns that this directive supports:
//  1. Logo only (currently only used for PNC post-lead authorization page)
//  2. Logo + header blurb + login link + icon badge
//  3. Logo + header links (e.g. "FAQ", "Contact Us") + login link + icon badge
//  4. Logo + header links + header dropwdown menu + icon badge
//
//  #1-3 are only in effect when the user is unauthenticated, and the login link
//    is conditionally hidden on /login and /myoffer pages
//  #3-4 header links + dropdown anchor collapse into a hamburger menu ☰ in mobile
//  #4 is used in the customer application for rates_terms and beyond.
//
// Usage (in HAML)
// %amount_header2{ badge: { alt:"Company badge", src:"/imgs/badge.svg", srcSecondary: "/imgs/badge2.svg" }.to_json,
//   blurb: { text: "Already have an account?", showIf: "!isUserAuthenticated" }.to_json,
//   links: LINKS_ARRAY.to_json, (see below for details)
//   login_display_condition: ng_display_condition(:unauthenticated),
//   logo: { alt:"Company badge", src:"/imgs/logo.svg" }.to_json,
//   menu_anchor: "My Account",
//   show_links: ng_display_condition(:not_post_lead) }

// Link properties:
// {
//   displayText:STRING
//   href:STRING (URL or path; note that`javascript:void(0)` is not allowed)
//   target:"_self"|"_blank"
//   ngIf:#ng_display_condition
//   alwaysInDrawer:BOOLEAN
//   modal:HASH{
//     name:STRING
//     config:HASH
//   }
// }

// Any link that has `false` for `alwaysInDrawer` will be diplayed horizontally
// in the header for desktop and will collapse into the dropdown drawer for mobile.
// `#ng_display_condition` is the result of the helper method in avant-basic > ApplicationController

// NOTE: Currently blurbs are incompatible with any other inline header links and
// so header links will be hidden when the blurb condition is satisfied.

const amountHeader2 = ($timeout) => {
  return {
    restrict: "E",
    template: require("./template.html"),
    scope: {
      badge: "@",
      blurb: "@",
      links: "@",
      logo: "@",
      menuAnchor: "@",
      showLinks: "@",
      showLogin: "@",
      useHamburger: "@",
    },
    link: (scope) => {
      // DISPLAY HELPERS
      // Some values get `JSON.parse`d into booleans, others into stringified
      // Angular expressions that need to be `$eval`d.
      extractNgDisplayVal = linkNgIf => {
        if (typeof linkNgIf === "string") return scope.$eval(linkNgIf);
        return linkNgIf;
      };

      evalLinkConfig = (link) => {
        if (link.evalDisplayText)
          link.displayText = scope.$eval(link.evalDisplayText);
        return link;
      };

      scope.noop = () => {};

      scope.openAmountModal = (event, name, config) => {
        event.preventDefault(); // to prevent navigation to `/#`

        if (config.evalHref)
          config.href = scope.$eval(config.evalHref);

        scope.$emit("amountModal:open", name, config);
      };

      refreshDisplayConditions = () => {
        scope.showLoginVal = scope.$eval(scope.showLogin);
        scope.showLinksVal = scope.$eval(scope.showLinks);
        if (scope.blurbAttrs) {
          scope.blurbAttrs.showIfVal = scope.$eval(scope.blurbAttrs.showIf);
        }
        scope.linksArr.map(link => {
          link.ngIfVal = extractNgDisplayVal(link.ngIf);
          return link;
        })
      };

      updateUserAuthStatus = (status) => {
        scope.userIsAuthenticated = status;
        refreshDisplayConditions();
      };

      // Parent methods
      scope.getPosMerchantRedirectUrl = (type) => {
        return scope.$parent.getPosMerchantRedirectUrl(type);
      };

      // PROCESS ATTRS PASSED IN
      // Optional config
      scope.badgeAttrs = scope.badge ? JSON.parse(scope.badge) : {};
      scope.blurbAttrs = scope.blurb ? JSON.parse(scope.blurb) : {};
      // Required config
      scope.logoAttrs = JSON.parse(scope.logo);
      scope.linksArr = JSON.parse(scope.links);

      // Initial evaluation of display conditions
      refreshDisplayConditions();

      // Listen for data processing events
      scope.$on("fetch_data:in_progress", () => {
        scope.loadingProgressData = true;
      });
      scope.$on("customer:login", (_ev, logged_in) => {
        updateUserAuthStatus(!!logged_in)
        scope.loadingProgressData = false;
      });
      scope.$on("fetch_data:complete", () => {
        if (scope.loadingProgressData)
          scope.loadingProgressData = false;
      });

      // Listen for point of sale product info, and evaluate
      // any JS expressions
      scope.$on("product:point_of_sale", (_ev, posInfo) => {
        angular.forEach(posInfo, (val, key) => {
          scope[key] = val;
        });
        angular.forEach(scope.linksArr, (link, idx) => {
          scope.linksArr[idx] = evalLinkConfig(link);
        });
        refreshDisplayConditions();
      });

      scope.backToMerchantLinkText = () => {
        return `Back to ${scope.merchant_details && scope.merchant_details.merchant_name}`;
      };
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountHeader2", ["$timeout", amountHeader2]);
